define(['underscore'], (_) => {
    return {
        $get: ['ContextService', '$filter', (ContextService, $filter) => ({
            createQuestionSetViewModelAddons: function (CONFIG, questionSets) {
                //Basler specific: decorate questions with Basler specific behaviour
                questionSets.forEach((questSet) => {
                    questSet.questions.forEach((quest) => {
                        quest.aspects.baslerReadonly = false; //can be improved making it readonly
                        quest.aspects.baslerAvailable = true; //can be improved making it readonly
                        quest.aspects.baslerHideValues = []; //can be improved making it readonly
                        if (ContextService.isPartnerProduct() && ContextService.getSubproductCode()) {
                            quest.translationParams = {_PARTNER: $filter('translate')(`quoteandbind.question.BSLDataUsageConfirmend.${ContextService.getSubproductCode().toLowerCase()}`)};
                        } else {
                            quest.translationParams = {};
                        }
                        const qconfig = _.findWhere(CONFIG, { CODE: quest.code });
                        if (qconfig) {
                            quest.answer = (qconfig.hasOwnProperty('DEFAULT_VALUE') ? qconfig.DEFAULT_VALUE : quest.answer);
                            quest.aspects.baslerReadonly = (qconfig.hasOwnProperty('READONLY') ? qconfig.READONLY : quest.aspects.baslerReadonly);
                            quest.aspects.baslerAvailable = (qconfig.hasOwnProperty('AVAILABLE') ? qconfig.AVAILABLE : quest.aspects.baslerAvailable);
                            quest.aspects.baslerHideValues = (qconfig.hasOwnProperty('HIDE_VALUES') ? qconfig.HIDE_VALUES : quest.aspects.baslerHideValues);
                        } else {
                            quest.answer = null;
                        }
                    });
                });
            },
        })],
    };
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/baslerquestionsets/BaslerQuestionSetService.js